import RockySetup from '@/services/Rocky/helper/rockyDatabase';
import { getBaseInterfaceInfoPromise } from '../rockyExperimentCtrl';

class BaseSweepConstructor {
  constructor() {
    this.ssn = new Map();
    this.content = new Map();
  }

  setInfo = (data, baseVerificationId, ddrType, projectVersion) => {
    const { ssn, content, designId } = data;
    this.content.set(baseVerificationId, { ...content, baseVerificationId, designId })
    if (ssn && ssn.length) {
      this.addList(ssn, baseVerificationId, ddrType, projectVersion)
    }
  }

  // getDataPromise = (baseVerificationId, update) => {
  //   return new Promise((resolve, reject) => {
  //     const content = this.getContent(baseVerificationId)
  //     if (content && !update) {
  //       resolve(JSON.parse(JSON.stringify(content)));
  //     } else {
  //       getBaseInterfaceInfoPromise(baseVerificationId).then(res => {
  //         if (res) {
  //           this.setInfo(baseVerificationId, { ...res })
  //           resolve(res);
  //         } else {
  //           resolve(null);
  //         }
  //       }, error => {
  //         console.error(error);
  //         resolve(null);
  //       })
  //     }
  //   })
  // }

  addList = (list, baseVerificationId, ddrType, projectVersion) => {
    for (let item of list) {
      const Interfaces = item.interfaces;
      const verificationName = item.name
      const contentInfo = RockySetup.mergeInterfacesInfo(Interfaces, verificationName, ddrType, projectVersion);
      this.ssn.set(item.id, { ...item, info: contentInfo, baseVerificationId })
    }
  }

  getContent = (baseId) => {
    return this.content.get(baseId)
  }

  getGroupInfo = (signalGroupId) => {
    return this.ssn.get(signalGroupId)
  }

  delete = (signalGroupId) => {
    this.ssn.delete(signalGroupId)
  }

  clearAll = () => {
    this.content = {}
    this.ssn = new Map();
  }
}

let baseSweepConstructor = new BaseSweepConstructor();
export default baseSweepConstructor;